/* =========================================================================
   OfficeLicense24 – Bewegung
   ------------------------------------------------------------------------
   Vier kleine Bausteine, alle ohne Fremdbibliothek und alle so gebaut,
   dass die Seite ohne sie vollstaendig benutzbar bleibt:

     1  Enthuellen    .ol-auf  – Inhalte blenden beim Scrollen sanft ein
     2  Spotlight     .ol-spot – ein Lichtfleck folgt dem Zeiger
     3  Kippen        .ol-kipp – leichte Neigung der Bildbuehne
     4  Laufband      .ol-band – Inhalt wird verdoppelt, damit die
                                 CSS-Schleife nahtlos laeuft

   Wichtig fuer Canyon: das Theme scrollt nicht das Dokument, sondern den
   Kasten `.page-wrapper` (html/body stehen auf overflow:hidden). Ein
   IntersectionObserver mit `root: null` misst gegen den Dokument-
   Sichtbereich und wuerde nie ausloesen. Deshalb wird der wirklich
   scrollende Vorfahr gesucht und als Wurzel gesetzt.

   Beruehrungsgeraete bekommen weder Spotlight noch Kippen: dort kostet
   das nur Rechenzeit und fuehlt sich klebrig an.
   ========================================================================= */
(function () {
  'use strict';

  var wenigBewegung = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var zeigergeraet = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ------------------------------------------------------ Scroll-Wurzel */
  function scrollWurzel() {
    var kasten = document.querySelector('.page-wrapper');
    if (!kasten) return null;
    var art = getComputedStyle(kasten).overflowY;
    if (art === 'auto' || art === 'scroll') return kasten;
    return null;
  }

  /* --------------------------------------------------------- 1 Enthuellen */
  function enthuellen() {
    var ziele = document.querySelectorAll('.ol-auf:not([data-ol-auf])');
    if (!ziele.length) return;

    // Ohne Beobachter (sehr alte Browser) oder bei reduzierter Bewegung:
    // sofort sichtbar schalten, nichts animieren.
    if (wenigBewegung || !('IntersectionObserver' in window)) {
      ziele.forEach(function (el) {
        el.dataset.olAuf = '1';
        el.classList.add('ist-da');
      });
      return;
    }

    var beobachter = enthuellen._b;
    if (!beobachter) {
      beobachter = enthuellen._b = new IntersectionObserver(function (eintraege, selbst) {
        eintraege.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('ist-da');
          selbst.unobserve(e.target);
        });
      }, {
        root: scrollWurzel(),
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.05
      });
    }

    var hoehe = window.innerHeight || document.documentElement.clientHeight;

    ziele.forEach(function (el, i) {
      el.dataset.olAuf = '1';
      // Geschwister staffeln sich, damit eine Reihe nacheinander erscheint.
      if (!el.style.getPropertyValue('--ol-verzug')) {
        var geschwister = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : i;
        el.style.setProperty('--ol-verzug', Math.min(geschwister, 6) * 70 + 'ms');
      }

      // Was beim Laden schon im Bild steht, wird sofort eingeblendet.
      // Sich dafuer auf den Beobachter zu verlassen war unzuverlaessig:
      // Canyon scrollt den Kasten .page-wrapper, und je nach Zeitpunkt
      // meldete der erste Durchlauf nichts - die Ueberschrift blieb dann
      // sekundenlang unsichtbar. Ein Rechteckvergleich ist hier eindeutig.
      var r = el.getBoundingClientRect();
      if (r.top < hoehe && r.bottom > 0) {
        requestAnimationFrame(function () { el.classList.add('ist-da'); });
        return;
      }
      beobachter.observe(el);
    });
  }

  // Sicherheitsnetz: was nach kurzer Zeit noch verborgen ist, wird
  // sichtbar gemacht. Ein unsichtbarer Absatz ist schlimmer als ein
  // Absatz ohne Animation.
  function notausgang() {
    document.querySelectorAll('.ol-auf:not(.ist-da)').forEach(function (el) {
      el.classList.add('ist-da');
    });
  }

  /* ---------------------------------------------------------- 2 Spotlight */
  function spotlight(el) {
    if (el.dataset.olSpot) return;
    el.dataset.olSpot = '1';
    var offen = false;
    el.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (offen) return;
      offen = true;
      requestAnimationFrame(function () {
        offen = false;
        var r = el.getBoundingClientRect();
        el.style.setProperty('--ol-x', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        el.style.setProperty('--ol-y', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      });
    }, { passive: true });
  }

  /* ------------------------------------------------------------- 3 Kippen */
  function kippen(el) {
    if (el.dataset.olKipp) return;
    el.dataset.olKipp = '1';
    var staerke = parseFloat(el.dataset.kippStaerke || '6');
    var offen = false;

    el.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' || offen) return;
      offen = true;
      requestAnimationFrame(function () {
        offen = false;
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        el.style.setProperty('--ol-kipp-y', (x * staerke).toFixed(2) + 'deg');
        el.style.setProperty('--ol-kipp-x', (-y * staerke).toFixed(2) + 'deg');
      });
    }, { passive: true });

    el.addEventListener('pointerleave', function () {
      el.style.setProperty('--ol-kipp-x', '0deg');
      el.style.setProperty('--ol-kipp-y', '0deg');
    }, { passive: true });
  }

  /* ----------------------------------------------------------- 4 Laufband */
  // Die CSS-Schleife verschiebt die Spur um genau die halbe Breite. Damit
  // das nahtlos aussieht, muss der Inhalt exakt zweimal darin stehen.
  function laufband(band) {
    if (band.dataset.olBand) return;
    var spur = band.querySelector('.ol-band__spur');
    var gruppe = spur && spur.querySelector('.ol-band__gruppe');
    if (!spur || !gruppe) return;
    band.dataset.olBand = '1';
    var kopie = gruppe.cloneNode(true);
    kopie.setAttribute('aria-hidden', 'true');
    spur.appendChild(kopie);
  }

  /* ------------------------------------------------------------- Anwenden */
  function anwenden() {
    enthuellen();
    document.querySelectorAll('.ol-band').forEach(laufband);
    if (zeigergeraet && !wenigBewegung) {
      document.querySelectorAll('.ol-spot').forEach(spotlight);
      document.querySelectorAll('.ol-kipp').forEach(kippen);
    }
  }

  function start() {
    // Erst hier wird der Startzustand der Enthuellung aktiviert. Bricht
    // das Skript vorher ab, ist nichts unsichtbar.
    if (!wenigBewegung) document.documentElement.setAttribute('data-ol-motion', '');
    anwenden();
    setTimeout(notausgang, 1500);

    // Empfehlungen, Filterergebnisse und der Theme-Editor schieben
    // Abschnitte nachtraeglich in die Seite.
    var geplant = false;
    new MutationObserver(function () {
      if (geplant) return;
      geplant = true;
      requestAnimationFrame(function () { geplant = false; anwenden(); });
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', anwenden);
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
